import { render, staticRenderFns } from "./PrizeView.vue?vue&type=template&id=6d8d8cd1&scoped=true"
import script from "./PrizeView.vue?vue&type=script&lang=js"
export * from "./PrizeView.vue?vue&type=script&lang=js"
import style0 from "./PrizeView.vue?vue&type=style&index=0&id=6d8d8cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d8cd1",
  null
  
)

export default component.exports